import React from 'react';
import PropTypes from 'prop-types';
import MUIModal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '../IconButton/IconButton';
import style from './Modal.style';

const Modal = ({
  id,
  children,
  container,
  open,
  onClose,
  size,
  headerData,
  classes: { modal: modalClass, paper: paperClass, header: headerClass },
  ...props
}) => (
  <MUIModal
    id={id}
    container={container}
    open={open}
    onClose={onClose}
    className={modalClass}
    css={[style.container.base]}
    role="dialog"
    BackdropProps={{ role: 'presentation' }}
    {...props}
  >
    <div
      className={paperClass}
      css={[style.paper.base, style.paper.bySize[size]]}
    >
      {headerData && (
        <div className={headerClass} css={[style.header.base]}>
          <IconButton
            size={headerData.iconSize}
            label="Close"
            icon={CloseIcon}
            type="secondary"
            onClick={onClose}
          />
          <div css={[style.header.titleContainer]}>
            {headerData.icon ? (
              <i css={[style.header.headerIcon]}>{headerData.icon}</i>
            ) : null}
            <div>
              {headerData.title}
              {/* eslint-disable-next-line react/prop-types */}
              {headerData.hint && (
                /* eslint-disable-next-line react/prop-types */
                <div css={[style.header.hintContainer]}>{headerData.hint}</div>
              )}
            </div>
          </div>
          {headerData.children}
        </div>
      )}
      {children}
    </div>
  </MUIModal>
);

Modal.defaultProps = {
  onClose: () => {},
  classes: {},
  size: 'default',
  headerData: null,
  container: undefined,
};

Modal.propTypes = {
  size: PropTypes.oneOf(['default', 'small', 'fullscreen', 'medium']),
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  container: PropTypes.func,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  classes: PropTypes.shape({
    modal: PropTypes.string,
    paper: PropTypes.string,
    header: PropTypes.string,
  }),
  headerData: PropTypes.shape({
    children: PropTypes.node,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    icon: PropTypes.element,
    iconSize: PropTypes.oneOf(['xSmall', 'small', 'medium']),
  }),
};

export default Modal;
